import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ShareWithClientModal.scss";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { localSetColumnsSharing } from "src/redux";
import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import { RootState } from "src/redux/reducers";
import { TasksColumn } from "src/redux/task/taskReducer";
import { wsAxiosPatch } from "../../../helpers/wsAxios";
import { API_URLS } from "../../../utils/API_URLS";
import Modal, {
  ModalColumn,
  ModalText,
  ModalTitle,
  OutsideClickModes,
} from "../../components/Modal/Modal";
import { StackedAvatars } from "../../components/StackedAvatars/StackedAvatars";

interface ShareWithClientModalProps {
  onClose: () => void;
  columnFromApi: TasksColumn;
}

function ShareWithClientModal({
  onClose,
  columnFromApi,
}: ShareWithClientModalProps) {
  const [isEditableForClient, setIsEditableForClient] = useState(
    columnFromApi.metaFieldSharedEditable,
  );

  const {
    projectReducer: { projectBasicData },
  } = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  const toggleEditableForClient = () => {
    setIsEditableForClient((prev) => !prev);
  };

  const shareColumn = async () => {
    await wsAxiosPatch(
      API_URLS.shareColumn.replace(":metaFieldId:", columnFromApi.metaFieldId),
      {
        editable: isEditableForClient,
      },
      `Error occurred during sharing column`,
      () => {},
      () => {
        dispatch(localSetColumnsSharing([columnFromApi.metaFieldId], true));
      },
    );
    onClose();
  };

  return (
    <Modal
      className="share-with-client-modal"
      onClose={onClose}
      displayCancelButton
      closeButtonVariant="white-with-light-grey-border"
      closeButtonText={
        <IDHFormattedMessage id="ws_cancel" defaultMessage="Cancel" />
      }
      onConfirmClick={shareColumn}
      confirmButtonText={
        <IDHFormattedMessage id="ws_share" defaultMessage="Share" />
      }
      outsideClick={OutsideClickModes.Allow}
    >
      <ModalTitle>
        <IDHFormattedMessage
          id="ws_share_with_client"
          defaultMessage="Share with Client"
        />
        <StackedAvatars
          avatars={
            projectBasicData?.members.filter((member) => member.isClient) ?? []
          }
          maxAvatars={2}
          stackedUsers
        />
      </ModalTitle>
      <ModalText>
        <IDHFormattedMessage
          id="ws_share_with_client_modal_text"
          defaultMessage="Please confirm that you want to share with Client:"
        />
      </ModalText>

      <ModalColumn className="share-with-client-modal__column">
        <div className="share-with-client-modal__header">
          <div>
            <IDHFormattedMessage id="ws_field" defaultMessage="Field" />
          </div>

          <div className="share-with-client-modal__header-editable-label">
            <IDHFormattedMessage
              id="ws_editable_for_client"
              defaultMessage="Editable for Client"
            />
          </div>
        </div>

        <div className="share-with-client-modal__row">
          <span className="share-with-client-modal__field-name">
            {columnFromApi.metaFieldName}
          </span>

          <CustomSwitch
            checked={isEditableForClient}
            onChange={toggleEditableForClient}
          />
        </div>
      </ModalColumn>
    </Modal>
  );
}

export default ShareWithClientModal;
